// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-spinner {
  margin: 32px;
  height: 72px;
  width: 72px;
}

.payment-input {
  margin: 6px 12px;
  background: var(--payment-modal-item-background, white);
  border-radius: 5px;
  padding: var(--ion-margin);
  color: var(--ion-color-black);
}

.header-msg {
  font-size: 18px;
  font-family: AppFontBold, sans-serif;
}

.payment-method-row {
  min-height: 56px;
  align-items: center;
  margin: 6px 12px;
  background: white;
  border-radius: 5px;
}
.payment-method-row > ion-col {
  padding: 0;
}
.payment-method-row > ion-col ion-item {
  overflow: hidden;
  --background: #00000000;
}
.payment-method-row > ion-col ion-item > ion-radio {
  --color: var(--ion-color-primary);
  --color-checked: var(--ion-color-primary);
  margin: 11px 16px 10px 4px;
}
.payment-method-row > ion-col ion-item > ion-label {
  color: var(--ion-color-black);
  font-weight: bold;
}

.back-icon {
  margin-right: 10px;
  width: 30px;
}

.bottom-end {
  position: absolute;
  bottom: 0;
  right: 0;
  height: 300px;
  width: 142px;
}

.padding-5 {
  padding: 5px;
}

ion-content {
  --background: #f9f9f9;
}

.icon-size {
  margin: 0px;
  zoom: var(--payment-icon-size);
}

.cash-block {
  display: flex;
  justify-content: center;
}
.cash-block ion-button {
  width: 60%;
  margin: 10px auto;
}

.payment-link {
  width: 100%;
  height: 100%;
  padding: 15px;
  font-size: 18px;
  font-family: AppFontBold, sans-serif;
  background: var(--ion-color-tertiary);
  color: white;
  text-decoration: none;
  text-align: center;
  margin-bottom: 30px;
  border-radius: 28px;
}

.hint_text_block {
  padding: 20px;
  color: var(--ion-color-black);
  font-family: AppFont, sans-serif;
}`, "",{"version":3,"sources":["webpack://./src/smoothr-web-app-core/components/payment-modal/payment-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;EACE,gBAAA;EACA,uDAAA;EACA,kBAAA;EACA,0BAAA;EACA,6BAAA;AACF;;AAEA;EACE,eAAA;EACA,oCAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AACF;AACE;EACE,UAAA;AACJ;AACI;EACE,gBAAA;EACA,uBAAA;AACN;AACM;EACE,iCAAA;EACA,yCAAA;EACA,0BAAA;AACR;AAEM;EACE,6BAAA;EACA,iBAAA;AAAR;;AAMA;EACE,kBAAA;EACA,WAAA;AAHF;;AAMA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;EACA,YAAA;AAHF;;AAMA;EACE,YAAA;AAHF;;AAMA;EACE,qBAAA;AAHF;;AAMA;EACE,WAAA;EACA,8BAAA;AAHF;;AAMA;EACE,aAAA;EACA,uBAAA;AAHF;AAKE;EACE,UAAA;EACA,iBAAA;AAHJ;;AAMA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,oCAAA;EACA,qCAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EAEA,mBAAA;EACA,mBAAA;AAJF;;AAMA;EACE,aAAA;EACA,6BAAA;EACA,gCAAA;AAHF","sourcesContent":["ion-spinner {\n  margin: 32px;\n  height: 72px;\n  width: 72px;\n}\n\n.payment-input {\n  margin: 6px 12px;\n  background: var(--payment-modal-item-background, white);\n  border-radius: 5px;\n  padding: var(--ion-margin);\n  color: var(--ion-color-black);\n}\n\n.header-msg {\n  font-size: 18px;\n  font-family: AppFontBold, sans-serif;\n}\n\n.payment-method-row {\n  min-height: 56px;\n  align-items: center;\n  margin: 6px 12px;\n  background: white;\n  border-radius: 5px;\n\n  > ion-col {\n    padding: 0;\n\n    ion-item {\n      overflow: hidden;\n      --background: #00000000;\n\n      > ion-radio {\n        --color: var(--ion-color-primary);\n        --color-checked: var(--ion-color-primary);\n        margin: 11px 16px 10px 4px;\n      }\n\n      > ion-label {\n        color: var(--ion-color-black);\n        font-weight: bold;\n      }\n    }\n  }\n}\n\n.back-icon {\n  margin-right: 10px;\n  width: 30px;\n}\n\n.bottom-end {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  height: 300px;\n  width: 142px;\n}\n\n.padding-5 {\n  padding: 5px;\n}\n\nion-content {\n  --background: #f9f9f9;\n}\n\n.icon-size {\n  margin: 0px;\n  zoom: var(--payment-icon-size);\n}\n\n.cash-block {\n  display: flex;\n  justify-content: center;\n\n  ion-button {\n    width: 60%;\n    margin: 10px auto;\n  }\n}\n.payment-link {\n  width: 100%;\n  height: 100%;\n  padding: 15px;\n  font-size: 18px;\n  font-family: AppFontBold, sans-serif;\n  background: var(--ion-color-tertiary);\n  color: white;\n  text-decoration: none;\n  text-align: center;\n\n  margin-bottom: 30px;\n  border-radius: 28px;\n}\n.hint_text_block {\n  padding: 20px;\n  color: var(--ion-color-black);\n  font-family: AppFont, sans-serif;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
